import { render, staticRenderFns } from "./childOutinsuranceCompany.vue?vue&type=template&id=62066894&scoped=true&"
import script from "./childOutinsuranceCompany.vue?vue&type=script&lang=js&"
export * from "./childOutinsuranceCompany.vue?vue&type=script&lang=js&"
import style0 from "./childOutinsuranceCompany.vue?vue&type=style&index=0&id=62066894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62066894",
  null
  
)

export default component.exports